import React from 'react';
import styled from 'styled-components';

interface ButtonProps {
    text: string;
    disabled?: boolean;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const Button = styled.button`
    border-width: 0px;
    background-color: ${props => props.theme.colors.brand[1]};
    cursor: pointer;
    color: #fff;
    border-radius: 2px;
    font-weight: bold;
    width: 100%;
    padding: 20px 0;
    font-size: 16px;
    transition: all 0.2s;
    &:hover {
        background-color: ${props => props.theme.colors.brand[0]};
    }
`;

export default ({ text, disabled, onClick }: ButtonProps) => (
    <Button disabled={disabled} onClick={onClick}>
        {text}
    </Button>
);



// WEBPACK FOOTER //
// ./src/components/Button.tsx